import { FormattedMessage } from 'react-intl';

import type { ReducedLettersType } from '@xing-com/crate-career-hub-common';
import { Glossary } from '@xing-com/crate-career-hub-common';
import { useLoginState } from '@xing-com/crate-hooks-use-login-state';
import { Headline } from '@xing-com/typography';

import { RegisterBanner } from './register-banner';
import { RelevantLinks } from './relevant-links';

export type LoggedOutFooterType = {
  openInSameTab?: boolean;
  reducedLetters?: ReducedLettersType;
  topicKey?: string;
};

export const LoggedOutFooter: React.FC<LoggedOutFooterType> = ({
  openInSameTab = false,
  reducedLetters,
  topicKey,
}) => {
  const { isLoggedOut } = useLoginState();

  return isLoggedOut ? (
    <>
      <RegisterBanner topicKey={topicKey} />
      <RelevantLinks topicKey={topicKey} />
      <Headline size="large" as="strong">
        <FormattedMessage id="CAREER_HUB_GLOSSARY_TITLE" />
      </Headline>
      <Glossary {...{ openInSameTab, reducedLetters }} />
    </>
  ) : null;
};
